import * as types from "../actions/actionTypes";
import { getAllCompanysResponse, getCompanyByIdResponse } from "../actions";
import { createEntitySagas } from "./sagaHelpers";

export const companyEntity = createEntitySagas({
  entity: "company",
  endpoint: "companies",
  label: "Company",
  scope: "none",
  selectSlice: (state) => state.company,
  listKey: "companies",
  types: {
    getAll: types.GET_ALL_COMPANYS,
    getById: types.GET_COMPANY_BY_ID,
    create: types.CREATE_COMPANY,
    update: types.UPDATE_COMPANY,
    remove: types.DELETE_COMPANY,
  },
  actions: { getAllResponse: getAllCompanysResponse, getByIdResponse: getCompanyByIdResponse },
});

export const companySaga = companyEntity.watcher;
